module.exports = __webpack_public_path__ + "static/media/input4.93bb8522.jpg";